import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
	Button,
	Collapse,
	Input,
	InputGroup,
	Nav,
	Navbar as RC_Navbar,
	NavbarBrand,
	NavbarToggler,
	NavItem,
	NavLink,
} from 'reactstrap';
import { MemoraLogoPrimary } from '../assets';
import HeaderLogo from '../assets/imgs/new/header-logo.svg';
import { logout } from '../redux/actions/auth.action';

function Navbar({ search, setSearch }) {
	const [collapsed, setCollapsed] = useState(true);
	const authUser = useSelector(state => state.authUser);
	const dispatch = useDispatch();
	const history = useHistory();
	const toggleNavbar = () => {
		setCollapsed(!collapsed);
	};
	return (
		<div>
			<RC_Navbar expand='lg' className='px-0'>
				<NavbarBrand tag={Link} to='/main'>
					<img src={HeaderLogo} />
				</NavbarBrand>
				<NavbarToggler onClick={toggleNavbar}>
					{collapsed ? (
						<i className='fa fa-bars'></i>
					) : (
						<i className='fa fa-times'></i>
					)}
				</NavbarToggler>
				<Collapse isOpen={!collapsed} navbar>
					<Nav navbar>
						<NavItem>
							<NavLink tag={Link} to='/main/about'>
								About Us
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink tag={Link} to='/main/Features'>
								Features
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink tag={Link} to='/main/price'>
								Price
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink tag={Link} to='/main/blog'>
								Blog
							</NavLink>
						</NavItem>
					</Nav>
					<Nav className='ml-auto d-flex align-items-center mt-3 mt-lg-0'>
						<span className='d-none d-xl-block mr-3'>
							<InputGroup>
								<Input
									placeholder='Search'
									value={search}
									onChange={e => {
										setSearch(e.target.value);
										if (
											history.location.pathname !==
											'/main/PublicMemoirs'
										) {
										history.push('/main/PublicMemoirs');
										}
									}}
								/>
								<i
									className='fa fa-search position-absolute'
									style={{
										top: '50%',
										color: '#C4C4C4',
										left: 10,
										transform: 'translateY(-50%)',
										zIndex: 900,
									}}
								></i>
							</InputGroup>
						</span>
						{authUser && authUser.id ? (
							<Button
								onClick={e =>
									history.push('/dashboard/manage-account')
								}
								className='btn-outline landing-btn navbar-btn '
							>
								Dashboard
							</Button>
						) : (
							<Button
								onClick={e =>
									history.push('/dashboard/register')
								}
								className='btn-outline landing-btn navbar-btn'
							>
								Log in
							</Button>
						)}

						{authUser && authUser.id && (
							<Button
								onClick={e => dispatch(logout())}
								className='btn-outline landing-btn ml-3 navbar-btn'
							>
								Log out
							</Button>
						)}
					</Nav>
				</Collapse>
			</RC_Navbar>
		</div>
	);
}

export default Navbar;

// export default withRouter(Navbar);
